module.exports = __webpack_public_path__ + "static/media/NextDisabled-alt.7c915446.svg";